export enum Roles {
  underwriter = "underwriter",
  loanOfficer = "loan_officer",
  loanProcessor = "loan_processor",
  creditCommittee = "credit_committee"
}

export enum EscalationTarget {
  processor = "processor",
  underwriter = "underwriter",
  creditCommittee = "creditCommittee"
}
